import { Module } from 'vuex';
import { actions } from '@/store/actions/document-view.actions';
import { mutations } from '@/store/mutations/document-view.mutations';
import { getters } from '@/store/getters/document-view.getters';
import { RootState } from '@/store/store';
import { ISender } from '@/types/Sender';
import { IRecipient } from '@/types/Recipient';
import { IDocumentTracking } from '@/document-tracking/types/document-tracking';
import { IPreviewToken } from '@/dealroom/document/types/preview-token';
import { IDocumentEventItem } from '@/document-view/types/document-events-item';

export const namespace = 'documentView';

export interface IDocumentViewState {
  documentId: string;
  isSigning: boolean | number;
  isSigningOrder: boolean | number;
  isLoadingDocument: boolean;
  isLoadingRecipient: boolean;
  recipients: IRecipient[];
  sender: ISender;
  tracking: IDocumentTracking;
  selectedRecipientId: string;
  previewToken: IPreviewToken;
  modals: {
    showCancelSchedule: boolean;
  };
  events: IDocumentEventItem[];
}

export const state: IDocumentViewState = {
  documentId: '',
  isSigning: false,
  isSigningOrder: false,
  isLoadingDocument: false,
  isLoadingRecipient: false,
  recipients: [],
  tracking: null,
  sender: {
    email: '',
    name: '',
    thumbUrl: '',
    senderId: '',
  },
  selectedRecipientId: null,
  previewToken: {
    jwt: null,
    exp: null,
  },
  modals: {
    showCancelSchedule: false,
  },
  events: [],
};

const namespaced = true;

export const documentView: Module<IDocumentViewState, RootState> = {
  actions,
  namespaced,
  mutations,
  getters,
  state,
};
